export const SITEMAP_PATH = '/Sitemap/edit.html';
export const ADVISORY_CONTENT_PATH = '/Advisory_Content/edit.html';
//# sourceMappingURL=constants.js.map